<template>
  <div class="pic-img">
  <swiper :options="swiperOption"  ref="mySwiper">
    <!-- 渲染内容 -->
    <swiper-slide v-for="(item,index) in items" :key="index">
      <router-link class="picture-item" :to="`/event/${item.id}`" target="_blank" :style="{'backgroundImage': `url(${item.notice_image})`, 'height': itemHeight}">
      </router-link>
    </swiper-slide>
    <!-- 轮播小圆点 -->
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// require('swiper/dist/css/swiper.css')
import { mapState } from 'vuex'

export default {
  props: ['items', 'itemHeight'],
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        effect: 'fade',
        loop: false,
        autoplay: 3000,
        speed: 1000,
        fade: {
          crossFade: false
        },
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        bulletClass: 'my-bullet',
        bulletActiveClass: 'my-bullet-active'
      }
    }
  },
  created () {},
  // 定义这个swiper对象
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  mounted () {},
  beforeDestroy () {}
}
</script>
<style lang="scss">
@import '~swiper/dist/css/swiper.css';

.swiper-pagination-bullets {
  display: flex;
  justify-content: center;
  bottom: 24px !important;
}
.my-bullet {
  width: 20px;
  height: 5px;
  margin-right: 8px;
  background:rgba(255, 255, 255, .1);
  border-radius: 3px;
  &:last-child {
    margin-right: 0;
  }
}
.my-bullet.my-bullet-active {
  background: rgba(215, 179, 117, 1);
}
.picture-item{
  display: block;
  width: 100%;
  border-radius: 5px;
  background-position: center center;
  background-size: cover;
}
</style>
